(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyServiceCategoryDialogController', CompanyServiceCategoryDialogController);

    CompanyServiceCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceCategory', 'SettingInfo', 'Company', 'Servant', 'AlbumInfo', 'ServiceCategoryCustom'];

    function CompanyServiceCategoryDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceCategory, SettingInfo, Company, Servant, AlbumInfo, ServiceCategoryCustom) {
        var vm = this;
        vm.scope = $scope;
        vm.serviceCategory = entity;
        vm.clear = clear;
        vm.save = save;
        //vm.settinginfos = SettingInfo.query();
        //vm.companies = Company.query();
        //vm.servants = Servant.query();
        //vm.albuminfos = AlbumInfo.query();


        ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {

            if (vm.serviceCategory != null && vm.serviceCategory.id != null && result != null) {
                vm.servicecategories = result.filter(function (v) {

                        return (v.id != vm.serviceCategory.id && v.categoryName != "DEFAULT_CATEGORY")
                    }
                );
            } else {
                vm.servicecategories = result;
            }

        });


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.serviceCategory.id !== null) {
                    ServiceCategory.update(vm.serviceCategory, onSaveSuccess, onSaveError);
                } else {
                    ServiceCategory.save(vm.serviceCategory, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:serviceCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
